import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { Invite } from 'app/buyer/vendedores-convidados/_models/invite';
import { UserService } from 'app/_services/user.service';

@Injectable({ providedIn: 'root' })
export class BuyerDadosConviteService extends BaseService {
    private _domain: string = '/buyer/invites';

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public add(invite: Invite): Observable<any> {
        const buyerCompanyId = this.userService.userCompanyId();

        const body = {
            buyer_company_id: buyerCompanyId,
            company_name: invite.company_name,
            seller_name: invite.seller_name,
            seller_email: invite.seller_email,
            seller_phone: invite.seller_phone,
            seller_radio: invite.seller_radio
        };

        return this.config.executePost({ url: `${this._domain}`, body });
    }
}
